import React from 'react';
import { connect } from 'react-redux';

import classes from './Dropdown.scss';

import { filterByDuration, filterByPrice, filterByFlightDeparture, filterByFlightArrival } from '../../../../store/actions/index';

const dropdown = (props) => {

    let content = null;

    if (props.flightType.toUpperCase() === 'O') {
        content = 
        <div className={`p-3 u-absolute u-borderRadius6 u-backgroundColorWhite u-boxShadowNormal u-width250 u-right0 u-topNegative5 u-zIndex9`}>
            <div className={`mb-1`}>
                <p className={`u-textUppercase u-fontWeightMedium u-textColorDark u-fontSize13`}>{props.origin}-{props.destination}</p>
            </div>
            <ul>
                <li className={`${[classes.ListItem, props.departureFilterSelected ? classes.ListItemActive : null].join(' ')} pt-2 pb-2 u-cursorPointer u-flex justify-content-between align-items-center`} onClick={() => props.onFilterByFlightDeparture("onward")}>
                    <span className={`u-fontSize13 u-textColorDark`}>Departure:</span>
                    <div className={`u-flex align-items-center`}>
                        <span className={`u-fontSize11 u-textColorLight`}>Earliest to late</span>
                        <span className={[classes.Dot, props.departureFilterSelected ? classes.DotActive : null].join(' ')}></span>
                    </div>
                </li>
                <li className={`${[classes.ListItem, props.arrivalFilterSelected ? classes.ListItemActive : null].join(' ')} pt-2 pb-2 u-cursorPointer u-flex justify-content-between align-items-center`} onClick={() => props.onFilterByFlightArrival("onward")}>
                    <span className={`u-fontSize13 u-textColorDark`}>Arrival:</span>
                    <div className={`u-flex align-items-center`}>
                        <span className={`u-fontSize11 u-textColorLight`}>Earliest to late</span>
                        <span className={[classes.Dot, props.arrivalFilterSelected ? classes.DotActive : null].join(' ')}></span>
                    </div>
                </li>
                <li className={`${[classes.ListItem, props.durationFilterSelected ? classes.ListItemActive : null].join(' ')} pt-2 pb-2 u-cursorPointer u-flex justify-content-between align-items-center`} onClick={() => props.onFilterByDuration("onward")}>
                    <span className={`u-fontSize13 u-textColorDark`}>Duration:</span>
                    <div className={`u-flex align-items-center`}>
                        <span className={`u-fontSize11 u-textColorLight`}>Low to High</span>
                        <span className={[classes.Dot, props.durationFilterSelected ? classes.DotActive : null].join(' ')}></span>
                    </div>
                </li>
                <li className={`${[classes.ListItem, props.priceFilterSelected ? classes.ListItemActive : null].join(' ')} pt-2 pb-2 u-cursorPointer u-flex justify-content-between align-items-center`} onClick={() => props.onFilterByPrice("onward")}>
                    <span className={`u-fontSize13 u-textColorDark`}>Price:</span>
                    <div className={`u-flex align-items-center`}>
                        <span className={`u-fontSize11 u-textColorLight`}>Low to High</span>
                        <span className={[classes.Dot, props.priceFilterSelected ? classes.DotActive : null].join(' ')}></span>
                    </div>
                </li>
            </ul>
        </div>;
    } else {
        content = 
        <div className={`p-3 u-absolute u-borderRadius6 u-backgroundColorWhite u-boxShadowNormal u-width250 u-right0 u-topNegative5 u-zIndex9`}>
            <div className={`mb-1`}>
                <p className={`u-textUppercase u-fontWeightMedium u-textColorDark u-fontSize13`}>{props.origin}-{props.destination}</p>
            </div>
            <ul>
                <li className={`${[classes.ListItem, props.departureFilterSelected ? classes.ListItemActive : null].join(' ')} pt-2 pb-2 u-cursorPointer u-flex justify-content-between align-items-center`} onClick={() => props.onFilterByFlightDeparture("onward")}>
                    <span className={`u-fontSize13 u-textColorDark`}>Departure:</span>
                    <div className={`u-flex align-items-center`}>
                        <span className={`u-fontSize11 u-textColorLight`}>Earliest to late</span>
                        <span className={[classes.Dot, props.departureFilterSelected ? classes.DotActive : null].join(' ')}></span>
                    </div>
                </li>
                <li className={`${[classes.ListItem, props.arrivalFilterSelected ? classes.ListItemActive : null].join(' ')} pt-2 pb-2 u-cursorPointer u-flex justify-content-between align-items-center`} onClick={() => props.onFilterByFlightArrival("onward")}>
                    <span className={`u-fontSize13 u-textColorDark`}>Arrival:</span>
                    <div className={`u-flex align-items-center`}>
                        <span className={`u-fontSize11 u-textColorLight`}>Earliest to late</span>
                        <span className={[classes.Dot, props.arrivalFilterSelected ? classes.DotActive : null].join(' ')}></span>
                    </div>
                </li>
                <li className={`${[classes.ListItem, props.durationFilterSelected ? classes.ListItemActive : null].join(' ')} pt-2 pb-2 u-cursorPointer u-flex justify-content-between align-items-center`} onClick={() => props.onFilterByDuration("onward")}>
                    <span className={`u-fontSize13 u-textColorDark`}>Duration:</span>
                    <div className={`u-flex align-items-center`}>
                        <span className={`u-fontSize11 u-textColorLight`}>Low to High</span>
                        <span className={[classes.Dot, props.durationFilterSelected ? classes.DotActive : null].join(' ')}></span>
                    </div>
                </li>
                <li className={`${[classes.ListItem, props.priceFilterSelected ? classes.ListItemActive : null].join(' ')} pt-2 pb-2 u-cursorPointer u-flex justify-content-between align-items-center`} onClick={() => props.onFilterByPrice("onward")}>
                    <span className={`u-fontSize13 u-textColorDark`}>Price:</span>
                    <div className={`u-flex align-items-center`}>
                        <span className={`u-fontSize11 u-textColorLight`}>Low to High</span>
                        <span className={[classes.Dot, props.priceFilterSelected ? classes.DotActive : null].join(' ')}></span>
                    </div>
                </li>
            </ul>
            <div className={`mb-1 mt-2`}>
                <p className={`u-textUppercase u-fontWeightMedium u-textColorDark u-fontSize13`}>{props.destination}-{props.origin}</p>
            </div>
            <ul>
                <li className={`${[classes.ListItem, props.returnDepartureFilterSelected ? classes.ListItemActive : null].join(' ')} pt-2 pb-2 u-cursorPointer u-flex justify-content-between align-items-center`} onClick={() => props.onFilterByFlightDeparture("return")}>
                    <span className={`u-fontSize13 u-textColorDark`}>Departure:</span>
                    <div className={`u-flex align-items-center`}>
                        <span className={`u-fontSize11 u-textColorLight`}>Earliest to late</span>
                        <span className={[classes.Dot, props.returnDepartureFilterSelected ? classes.DotActive : null].join(' ')}></span>
                    </div>
                </li>
                <li className={`${[classes.ListItem, props.returnArrivalFilterSelected ? classes.ListItemActive : null].join(' ')} pt-2 pb-2 u-cursorPointer u-flex justify-content-between align-items-center`} onClick={() => props.onFilterByFlightArrival("return")}>
                    <span className={`u-fontSize13 u-textColorDark`}>Arrival:</span>
                    <div className={`u-flex align-items-center`}>
                        <span className={`u-fontSize11 u-textColorLight`}>Earliest to late</span>
                        <span className={[classes.Dot, props.returnArrivalFilterSelected ? classes.DotActive : null].join(' ')}></span>
                    </div>
                </li>
                <li className={`${[classes.ListItem, props.returnDurationFilterSelected ? classes.ListItemActive : null].join(' ')} pt-2 pb-2 u-cursorPointer u-flex justify-content-between align-items-center`} onClick={() => props.onFilterByDuration("return")}>
                    <span className={`u-fontSize13 u-textColorDark`}>Duration:</span>
                    <div className={`u-flex align-items-center`}>
                        <span className={`u-fontSize11 u-textColorLight`}>Low to High</span>
                        <span className={[classes.Dot, props.returnDurationFilterSelected ? classes.DotActive : null].join(' ')}></span>
                    </div>
                </li>
                <li className={`${[classes.ListItem, props.returnPriceFilterSelected ? classes.ListItemActive : null].join(' ')} pt-2 pb-2 u-cursorPointer u-flex justify-content-between align-items-center`} onClick={() => props.onFilterByPrice("return")}>
                    <span className={`u-fontSize13 u-textColorDark`}>Price:</span>
                    <div className={`u-flex align-items-center`}>
                        <span className={`u-fontSize11 u-textColorLight`}>Low to High</span>
                        <span className={[classes.Dot, props.returnPriceFilterSelected ? classes.DotActive : null].join(' ')}></span>
                    </div>
                </li>
            </ul>
        </div>;
    }

    return content;
}

const mapStateToProps = state => {
    return {
        departureFilterSelected: state.flights.departureFlightFiltersSelected,
        arrivalFilterSelected: state.flights.arrivalFlightFiltersSelected,
        durationFilterSelected: state.flights.durationFilterSelected,
        priceFilterSelected: state.flights.priceFilterSelected,
        returnDepartureFilterSelected: state.flights.returnDepartureFlightFiltersSelected,
        returnPriceFilterSelected: state.flights.returnPriceFilterSelected,
        returnDurationFilterSelected: state.flights.returnDurationFilterSelected,
        returnArrivalFilterSelected: state.flights.returnArrivalFlightFiltersSelected,
        origin: state.flights.requestParams.origin,
        destination: state.flights.requestParams.destination,
        flightType: state.flights.flightType
    }
}

const mapDispatchToProps = dispatch => {
    return {
        onFilterByDuration: (tripType) => dispatch(filterByDuration(tripType)),
        onFilterByPrice: (tripType) => dispatch(filterByPrice(tripType)),
        onFilterByFlightDeparture: (tripType) => dispatch(filterByFlightDeparture(tripType)),
        onFilterByFlightArrival: (tripType) => dispatch(filterByFlightArrival(tripType))
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(dropdown);


// WEBPACK FOOTER //
// ./src/components/Flight/TupleHeader/Dropdown/Dropdown.js